module.exports = __webpack_public_path__ + "img/icon-next-gray.9654d7c7.svg";